// SPA forms preventDefault and client-navigate, so Chrome's save-password heuristic never fires — ask explicitly.
// Feature-detected and best-effort: unsupported browsers and non-secure contexts simply no-op.
export async function saveCredential(email: string, password: string): Promise<void> {
  if (!email || !password) return
  if (typeof window === 'undefined') return
  if (!('credentials' in navigator) || !('PasswordCredential' in window)) return
  try {
    // PasswordCredential isn't in the default TS lib DOM types.
    const Ctor = (
      window as unknown as { PasswordCredential: new (data: { id: string; password: string }) => Credential }
    ).PasswordCredential
    const credential = new Ctor({ id: email, password })
    await navigator.credentials.store(credential)
  } catch {
    // Saving credentials is best-effort; never let it break the login flow.
  }
}
